<!--
  Usage:
    <ReportSection title="Personal Information">
      <table class="doc-table"> ... </table>
    </ReportSection>

    <ReportSection
      title="KYC Exceptions"
      :badge="exceptions.length"
      badge-tone="danger"
      v-if="exceptions.length"
    >
      ...
    </ReportSection>
-->
<template>
  <div class="doc-section">
    <div class="doc-section-head">
      <span class="doc-section-num">{{ sectionNumber }}</span>
      <span class="doc-section-title">{{ title }}</span>
      <span
        v-if="badge !== null && badge !== undefined"
        class="doc-pill doc-section-badge"
        :style="toneStyle(badgeTone)"
      >{{ badge }}</span>
    </div>
    <div class="doc-section-body">
      <slot />
    </div>
  </div>
</template>

<script>
import { toRoman } from '../utils/roman';
import reportFormatMixin from '../mixins/reportFormat.mixin';

export default {
  name: 'ReportSection',

  mixins: [reportFormatMixin],

  inject: {
    reportSectionRegistry: { default: null },
  },

  props: {
    title:     { type: String, required: true },
    badge:     { type: [String, Number], default: null },
    badgeTone: { type: String, default: 'neutral' },
  },

  data() {
    return {
      sectionToken: Symbol('report-section'),
    };
  },

  computed: {
    sectionNumber() {
      if (!this.reportSectionRegistry) return '';
      const idx = this.reportSectionRegistry.order.indexOf(this.sectionToken);
      return idx === -1 ? '' : toRoman(idx + 1);
    },
  },

  created() {
    if (this.reportSectionRegistry) {
      this.reportSectionRegistry.order.push(this.sectionToken);
    }
  },

  beforeDestroy() {
    if (this.reportSectionRegistry) {
      const idx = this.reportSectionRegistry.order.indexOf(this.sectionToken);
      if (idx !== -1) this.reportSectionRegistry.order.splice(idx, 1);
    }
  },
};
</script>